import { getIsNewThemeActive } from '../useTheme';
import { getCssVarName } from '../utils';

import {
  defaultTheme as newDeafultTheme,
  darkTheme as newDarkTheme,
  themeStyle as newThemeStyle,
} from './newTheme';
import {
  darkTheme,
  defaultTheme,
  themeStyle as oldThemeStyle,
} from './oldTheme';

export const getDefaultTheme = ({
  isNewThemeActive,
}: {
  isNewThemeActive?: boolean;
}) =>
  Object.entries(
    isNewThemeActive ? { ...defaultTheme, ...newDeafultTheme } : defaultTheme
  ).map(([key, value]) => `${getCssVarName(key)}: ${value};`);

export const getDarkTheme = ({
  isNewThemeActive,
}: {
  isNewThemeActive?: boolean;
}) =>
  Object.entries(
    isNewThemeActive ? { ...darkTheme, ...newDarkTheme } : darkTheme
  ).map(([key, value]) => `${getCssVarName(key)}: ${value};`);

export const themeStyle = new Proxy(oldThemeStyle, {
  get: (target, prop: string) => {
    try {
      const isNewThemeActive = getIsNewThemeActive();
      if (
        isNewThemeActive &&
        newThemeStyle[prop as keyof typeof newThemeStyle]
      ) {
        return newThemeStyle[prop as keyof typeof newThemeStyle];
      }
      return target[prop as keyof typeof themeStyle];
    } catch (e) {
      console.error(e);
      return target[prop as keyof typeof themeStyle];
    }
  },
});
